import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import styles from './styles.m.scss';

const propTypes = {
  as: PropTypes.any,
  children: PropTypes.any,
};

const defaultProps = {
  as: 'button',
};

const Action = ({ as: Component, children, ...props }) => {
  const footerClasses = cn('card-footer', 'btn', 'btn-primary');

  return (
    <Component className={footerClasses} {...props}>
      {children}
    </Component>
  );
};

Action.propTypes = propTypes;
Action.defaultProps = defaultProps;

export default Action;
